import axios from "axios"

const URL = process.env.REACT_APP_API_URL
const BASE_URL = `${URL}/api/blog-categories`
const axiosApi = axios.create({ baseURL: BASE_URL })

axiosApi.interceptors.request.use(req => {
    const token = JSON.parse(localStorage.getItem('token'));
    if (token) {
        req.headers.Authorization = token
    }
    return req
})

export const BlogCategoryApis = {
    listAll: async () => axiosApi.get(BASE_URL),
    create: async (data) => axiosApi.post(BASE_URL, data),
    update: async (id, data) => axiosApi.put(`${BASE_URL}/${id}`, data),
    delete: async (id) => axiosApi.delete(`${BASE_URL}/${id}`)
}
